<template>
  <form
    v-if="isSnapQL"
    ref="csvForm"
    :action="snapCsvUrl"
    method="POST"
    :target="iframeName"
    style="display: inline">
    <input type="hidden" name="authorization" :value="authToken" />
    <input type="hidden" name="context" :value="contextJson" />
    <button
      type="button"
      class="button is-small export-button"
      :class="{ 'is-loading disabled': isExporting }"
      @click="submitCsvForm">
      Download CSV
    </button>
    <iframe
      :name="iframeName"
      style="display: none"
      @load="onIframeLoad" />
  </form>
  <button
    v-else
    class="button is-small export-button"
    :class="{ 'is-loading disabled': isExporting }"
    @click="exportCsvLegacy">
    Download CSV
  </button>
</template>
<script>

  export default {
    props: {
      dashboardModule: {
        type: Object,
        required: true,
      },
      dashboardDataContext: {
        type: Object,
        required: true,
      },
      dashboardKey: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        isExporting: false,
      }
    },

    computed: {
      isSnapQL () {
        return this.$hasFeatureFlag('USE_SNAPQL')
      },
      authToken () {
        return this.$store.getters['auth/authToken']
      },
      contextJson () {
        return JSON.stringify(this.dashboardDataContext)
      },
      snapCsvUrl () {
        const companyId = this.$store.getters['companyId']
        const base = process.env.VUE_APP_EXPORTER_API_URL
        return `${base}/company/${companyId}/snap/dashboards/reports/${this.dashboardKey}/export/csv/modules/${this.dashboardModule.key}`
      },
      iframeName () {
        return `csv-download-${this.dashboardModule.key}`
      },
    },

    methods: {
      submitCsvForm () {
        this.isExporting = true
        this.$refs.csvForm.submit()
        setTimeout(() => {
          this.isExporting = false
        }, 3000)
      },
      onIframeLoad () {
        if (this.isExporting) {
          this.isExporting = false
        }
      },

      async exportCsvLegacy () {
        this.isExporting = true

        const response = await this.$apis.companyConfigs.getDashboardModuleCsv(
          this.dashboardKey,
          this.dashboardModule.key,
          this.dashboardDataContext
        )

        if (response) {
          const blob = new Blob([response,], { type: 'text/csv', })
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = 'dashboard_data.csv'
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(a)
        }

        this.isExporting = false
      },
    },
  }
</script>
<style scoped lang="scss">
.export-button {
  box-shadow: none !important;
  border: 1px solid #e0e0e0 !important;
}
</style>
